type QueryValue = string | string[]

const getCurrentSearch = () => {
  if (typeof window === 'undefined') return ''
  return window.location.search || ''
}

export const normalizeSearch = (search = getCurrentSearch()): string => {
  const query = search.startsWith('?') ? search.slice(1) : search
  // 兼容三方在已有 query 后继续使用 ? 拼参数的联登 URL。
  return query.replace(/\?/g, '&')
}

export const getSearchParams = (search = getCurrentSearch()): URLSearchParams => {
  return new URLSearchParams(normalizeSearch(search))
}

export const removeSearchParams = (search: string, names: string[]): string => {
  const params = getSearchParams(search)
  names.forEach(name => params.delete(name))
  const query = params.toString()
  return query ? `?${query}` : ''
}

export const getSearchFromPath = (path: string): string => {
  const queryStart = path.indexOf('?')
  if (queryStart === -1) return ''

  const hashStart = path.indexOf('#', queryStart)
  return path.slice(queryStart, hashStart === -1 ? undefined : hashStart)
}

export const getSearchParam = (name: string, search = getCurrentSearch()): string => {
  return getSearchParams(search).get(name) || ''
}

export const getQueryValue = (value: unknown): string => {
  if (Array.isArray(value)) {
    return value.find((item): item is string => typeof item === 'string' && item.length > 0) || ''
  }
  return typeof value === 'string' ? value : ''
}

export const isDongchaSource = (source?: unknown, search = getCurrentSearch()): boolean => {
  const sourceValue = source === undefined ? getSearchParam('source', search) : getQueryValue(source)
  return sourceValue.toLowerCase() === 'dongcha'
}

export const getCurrentSourceQuery = (): Record<string, string> => {
  const source = getSearchParam('source')
  return source ? { source } : {}
}

export const hasSearchParam = (name: string, search = getCurrentSearch()): boolean => {
  return getSearchParams(search).has(name)
}

export const parseSearchQuery = (search: string): Record<string, QueryValue> => {
  const query: Record<string, QueryValue> = {}

  getSearchParams(search).forEach((value, key) => {
    const current = query[key]
    if (current === undefined) {
      query[key] = value
      return
    }

    query[key] = Array.isArray(current) ? [...current, value] : [current, value]
  })

  return query
}
